import React, {useState, useEffect,useContext, useLayoutEffect, useRef, useCallback} from 'react'
import ELEMENTS from '../ELEMENTS'
import {Col} from'react-bootstrap'
import { Fragment } from 'react';
import styles from '../../css/COLUMN.module.css'
import AddColumn from '../../../Icons/AddColumn'
import Delete from '../../../Icons/Delete'
import "../column.css"
import ElemDeleteControl from "../ElemDeleteControlWrapper";
import { Zoom } from '@material-ui/core';
import Fade from "@material-ui/core/Fade";
import {useDispatch,addContexts,useSelector,updateStateInRedux} from "../../../Redux"
import { GetState, GetStateFromData, useElementWidth } from '../../../components/CustomHooks/CustomHooks';
import {formStateStore} from '../../../Redux/Store/store';
import {isMobile} from 'react-device-detect';
import { useTranslation } from 'react-i18next';
import { setDevicePreview , getTempCanWidth, updatePartialJSON, getTabIndex, validIndexFunction } from '../../../components/IFormDesignerLayout/IFormDesignerLogic';


const COLUMN =(props)=> {
    const data = props.data;
  const activeTabIndex = getTabIndex({...props.data, stepIndex: props?.stepIndex,sheetIndex: props?.sheetIndex,subStepIndex: props?.subStepIndex,sheetElementIndex: props?.data?.sheetElementIndex});
    let children = data.children;
    const [animate, setAnimate] = useState(false);
    const [columns, setColumns] = useState([]);
    var elem = document.getElementById(props.id);
    var columnStyle={};
    var styeJson = {
        height: "auto",
        border: "1px dashed transparent",
        minHeight:"40px",
        position: "relative"
    };
    const dispatch = useDispatch();
    const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
    const contexts = GetStateFromData(props.containerId);
    const {tempCanWidth, controlSelected, hoverColumn, devicePreview,tempCanWidthDesignPage} = GetState("tempCanWidth","controlSelected","hoverColumn","devicePreview","tempCanWidthDesignPage");
    const {getElementJson,updateJson, setMax_controlIdValue, IdPrecedence , openQuickToolFor,
        deleteControl ,applyChanges, formState2, formMataData, draggedObjType,draggedFrom,
        updateColumnWidth,addColumn,showAlertConfirmNotifications, handleListviewControlSwapping }=contexts.contexts;
    
    useEffect(() => {
        let flag = false;
        if(props?.isSubForm && !props?.data?.isSubForm) {
        props.data.isSubForm = props?.isSubForm;
        flag = true;
        }
        if(props?.buttonId && props?.data?.buttonId !== props?.buttonId) {
        props.data.buttonId = props?.buttonId;
        flag = true;
        }
        // if(flag)
        //     updatePartialJSON(props.data.id,props.data);
    },[props?.isSubForm, props?.buttonId])

    useEffect(() => {
        setAnimate(true);
        if(validIndexFunction(props.elementIndex) && !validIndexFunction(props.data.elementIndex))
        props.data.elementIndex = props.elementIndex;
        if(validIndexFunction(props.frameIndex) && !validIndexFunction(props.data.frameIndex))
        props.data.frameIndex = props.frameIndex;
        if(validIndexFunction(props.sheetIndex) && !validIndexFunction(props.data.sheetIndex))
        props.data.sheetIndex = props.sheetIndex;
        if(validIndexFunction(props.sheetElementIndex) && !validIndexFunction(props.data.sheetElementIndex))
        props.data.sheetElementIndex = props.sheetElementIndex;
        if(validIndexFunction(props.stepIndex) && !validIndexFunction(props.data.stepIndex))
        props.data.stepIndex = props.stepIndex;
        if(validIndexFunction(props.subStepIndex) && !validIndexFunction(props.data.subStepIndex))
        props.data.subStepIndex = props.subStepIndex;
        return () => {
            setAnimate(false);
        }
    }, [])
    
    useEffect(() => {
        if(props.data["style"] === undefined){
            props.data["style"] = {}
            props.data.style["heightselect"] = "set"
        }
    }, [])

    if(props.data.id==="column1"){
        console.log("column1", props.data);
    }

    var areChildrenPresent = false;

    const [colsState, setColState] = useState({
        colW: data.w?data.w:0,
        colXs:data.xs?data.xs:0,
        colSm:data.sm?data.sm:0,
        colMd:data.md?data.md:0
    });

    const prevColState = useRef();

    var parent_id=data?.parent_id;
    if(parent_id==="RootControl"){
      parent_id=props?.parentframeId;
    }

    const handleHighlightRow = useCallback(() => {
        if (!props?.previewmode) {
          makeResizableCol(props.id);
          makeResizableColHeight(props.id);
          makeResizableColWidthHeight(props.id);
    
          const ele = document.getElementById(data.id);
          const beforeEle = document.getElementById('before_' + props.id);
          const afterEle = document.getElementById('after_' + props.id);
    
          // Define event handlers for the main element (ele)
          const dragEnterHandler = (e) => {
            e.preventDefault();
            ele.classList.add('draggingCol');
          };
    
          const dragOverHandler = (e) => {
            var rect = e.target.getBoundingClientRect();
            var left = e.clientX - rect.left;
            var right = rect.right - e.clientX;
            var bottom = rect.bottom - e.clientY;
            e.preventDefault();
    
            if (left <= 25) {
              ele.classList.add('dragEnterLeft');
            } else {
              ele.classList.remove('dragEnterLeft');
            }
            if (right <= 25) {
              ele.classList.add('dragEnterRight');
            } else {
              ele.classList.remove('dragEnterRight');
            }
            if (bottom <= 25) {
              ele.classList.add('dragEnterBottom');
            } else {
              ele.classList.remove('dragEnterBottom');
            }
          };
    
          const dragLeaveHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom');
          };
    
          const dropHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom');
          };
    
          // Define event handlers for before and after elements
          const beforeDragEnterHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom');
            ele.classList.add('draggingBeforeAfterCol');
            beforeEle?.classList.add('draggingBeforeCol');
          };
    
          const afterDragEnterHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom');
            ele.classList.add('draggingBeforeAfterCol');
            afterEle?.classList.add('draggingAfterCol');
          };
    
          const beforeDragLeaveHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom', 'draggingBeforeAfterCol');
            beforeEle?.classList.remove('draggingBeforeCol');
          };
    
          const afterDragLeaveHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom', 'draggingBeforeAfterCol');
            afterEle?.classList.remove('draggingAfterCol');
          };
    
          const beforeDropHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom', 'draggingBeforeAfterCol');
            beforeEle?.classList.remove('draggingBeforeCol');
          };
    
          const afterDropHandler = (e) => {
            e.preventDefault();
            ele.classList.remove('draggingCol', 'dragEnterLeft', 'dragEnterRight', 'dragEnterBottom', 'draggingBeforeAfterCol');
            afterEle?.classList.remove('draggingAfterCol');
          };
    
          // Attach event listeners to the main element
          if (ele) {
            ele.addEventListener('dragenter', dragEnterHandler);
            ele.addEventListener('dragover', dragOverHandler);
            ele.addEventListener('dragleave', dragLeaveHandler);
            ele.addEventListener('drop', dropHandler);
            ele.setAttribute('listener', 'true');
          }
    
          // Attach event listeners to the before and after elements
          if (beforeEle) {
            beforeEle.addEventListener('dragenter', beforeDragEnterHandler);
            beforeEle.addEventListener('dragleave', beforeDragLeaveHandler);
            beforeEle.addEventListener('drop', beforeDropHandler);
            beforeEle.setAttribute('listener', 'true');
          }
    
          if (afterEle) {
            afterEle.addEventListener('dragenter', afterDragEnterHandler);
            afterEle.addEventListener('dragleave', afterDragLeaveHandler);
            afterEle.addEventListener('drop', afterDropHandler);
            afterEle.setAttribute('listener', 'true');
          }
    
          // Cleanup function to remove event listeners
          return () => {
            if (ele) {
              ele.removeEventListener('dragenter', dragEnterHandler);
              ele.removeEventListener('dragover', dragOverHandler);
              ele.removeEventListener('dragleave', dragLeaveHandler);
              ele.removeEventListener('drop', dropHandler);
            }
            if (beforeEle) {
              beforeEle.removeEventListener('dragenter', beforeDragEnterHandler);
              beforeEle.removeEventListener('dragleave', beforeDragLeaveHandler);
              beforeEle.removeEventListener('drop', beforeDropHandler);
            }
            if (afterEle) {
              afterEle.removeEventListener('dragenter', afterDragEnterHandler);
              afterEle.removeEventListener('dragleave', afterDragLeaveHandler);
              afterEle.removeEventListener('drop', afterDropHandler);
            }
          };
        }
      }, []);
    
      useLayoutEffect(() => {
        const cleanup = handleHighlightRow();
        return () => cleanup && cleanup();
      }, [props.data.children]);

    const [updatingColumnWidth,setUpdatingColumnWidth]=useState(false);
    const [updatingColumn,setUpdatingColumn]=useState(false);
    
    // useEffect(()=>{
    //     if(props?.previewmode)
    //     makeResizableCol(props.id);
    //     // makeResizableColHeight(props.id);
    // },[updatingColumnWidth]);

    // useEffect(()=>{
    //     console.log("updatingColumn", updatingColumn);
    // },[updatingColumn]);

    const after_colIndicator = (inlineStyle) => {
        return(
            <>
                {props && props.id && (
                <div col_id={props.id} id={"after_"+ props.id} control_id={props.id} parent_id={props.tabsheetId || parent_id} 
                className={styles.afterCol}
                style={{height: inlineStyle["height"]}}
                elem_type='col' key={'after_'+ props.id}
                frameindex={data.frameIndex} row_index={props.row_index} elementIndex={props.elementIndex} 
                sheetIndex={props.sheetIndex} sheetElementIndex={props.sheetElementIndex}
                // style={{height: inlineStyle["height"] && inlineStyle["height"] === "auto" ? "60px" : inlineStyle["height"]}}
                >
                </div>
                )}
            </>
        )
    }
    
    let before_colIndicator = (inlineStyle) => {
        return(
            <>
                {props && props.id && (
                    <div col_id={props.id} id={"before_"+ props.id} control_id={props.id} parent_id={props.tabsheetId || parent_id} 
                    className={styles.beforeCol}
                    style={{height: inlineStyle["height"]}}
                    elem_type='col' key={'before_'+ props.id}
                    frameindex={data.frameIndex} row_index={props.row_index} elementIndex={props.elementIndex} 
                    sheetIndex={props.sheetIndex} sheetElementIndex={props.sheetElementIndex}
                    // style={{height: inlineStyle["height"] && inlineStyle["height"] === "auto" ? "60px" : inlineStyle["height"]}}
                    >
                </div>
                )}
            </>
        )
    }
    
    var colsCrossed=0;
    var prevCol=0;
    var otherPrevColClasses=[];
    var colsToSet = 0;
    var classes;
    var addedMd = false;
    var prevBorder='';
    var prevData;
    
    function getFormState2(){
        return (formStateStore.getState().data.find(json => json.key === props.containerId))?.contexts?.formState2;
        
    }

    function makeResizableCol(div){
         
		var element = document.getElementById(div);
        var currentResizer = document.getElementById(div+'Resizer');
        var currentResizerLabel = document.getElementById(div+'ResizerLabel');
        var parentWidthinPx = element?.parentElement?.offsetWidth;
        var prevWidthInPx = element?.offsetWidth;
        if(currentResizer !==null){
            // if(document.getElementById(div)?.getAttribute("listener") !== "true"){
                currentResizer.addEventListener( 'mousedown', mousedownFunc );
                document.getElementById(div).setAttribute("listener", true);
            // }
        }
        var colWidthInPx =0;

        var resizingColwidth=false;
        let requestAnimationFrame;

        function mousedownFunc(e){
            
            function isResizing(e){
                if(e?.target?.id===div+"Resizer"){
                    return true;
                }
                else{
                    return false;
                }

            }
            resizingColwidth = isResizing(e);

            if( resizingColwidth ){
                window.resizerRefSent_col=e.target.getAttribute("name");
                prevWidthInPx = element.offsetWidth;
                classes = element.classList;
                let currentColWidthInPx
                if (translationStyles1) {
                    currentColWidthInPx = element.getBoundingClientRect().right - e.pageX;
                }
                else {
                    currentColWidthInPx = e.pageX - element.getBoundingClientRect().left;
                }
                element.style.width = currentColWidthInPx+'px';
                element.style.maxWidth = 'unset';
                element.style.minWidth = 'unset';


                currentResizer.style.opacity=1;
                currentResizerLabel.style.opacity=1;
                currentResizer.style.cursor='w-resize';
                parentWidthinPx = element.parentElement.offsetWidth;
                colWidthInPx = Math.floor(parentWidthinPx/12);
                element.classList.add('resizers');
                prevBorder = element.style.border;

                let noOfColsCalculated = (Math.floor(currentColWidthInPx/colWidthInPx));
                colsToSet = ( noOfColsCalculated + 1 );
                if(colsToSet > 12){
                    colsToSet = 12;
                } else if(colsToSet < 1){
                    colsToSet = 1;
                }
                currentResizerLabel.textContent = String(colsToSet);

                // for(var cls=0;cls<classes.length;cls++){
                //     var css_class = classes[cls];
                //     if(css_class.startsWith('col-')){
                //         element.classList.remove(css_class);
                //     }
                // }
                element.style.opacity=1;
                
                colsCrossed = 0;
                e.preventDefault();
                
                //for resizer
                currentResizer.style.opacity=1;
                currentResizerLabel.style.opacity=1;

                // window.addEventListener('mousemove', resize);
                // window.addEventListener('mouseup', stopResize);
                // window.removeEventListener('mousemove', resize);
                // window.removeEventListener('mouseup', stopResize);
                window.addEventListener('mousemove', resize);
                window.addEventListener('mouseup', stopResize);
            }
        }

        function resize(e){
            if(resizingColwidth){
            for(var cls=0;cls<classes.length;cls++){
                var css_class = classes[cls];
                if(css_class.startsWith('col-')){
                    element.classList.remove(css_class);
                }
            }
                var currentColWidthInPx;
                if (translationStyles1) {
                    currentColWidthInPx = element.getBoundingClientRect().right - e.pageX;
                }
                else {
                    currentColWidthInPx = e.pageX - element.getBoundingClientRect().left;
                }
            element.style.width = currentColWidthInPx+'px'; //To show smooth transition
            element.style.minWidth = currentColWidthInPx+'px';
            
            // element.style.minWidth = 'unset';

            // //console.log('currentColWidthInPx :: '+currentColWidthInPx);
            if(currentColWidthInPx < 0){
                currentColWidthInPx = 0;
            }
            else if(currentColWidthInPx > parentWidthinPx){
                currentColWidthInPx = parentWidthinPx-2;
            }
            //cols calculation
            var noOfColsCalculated = (Math.floor(currentColWidthInPx/colWidthInPx));
            if(noOfColsCalculated<1){
                noOfColsCalculated =1;
            } else if(noOfColsCalculated>12){
                noOfColsCalculated=12;
            }
            var totColsIncreased = Math.abs(prevCol - noOfColsCalculated);
            totColsIncreased = 1;
            // //console.log('totColsIncreased :: '+totColsIncreased);
            if((prevWidthInPx+(totColsIncreased*Math.floor(colWidthInPx/2)))<currentColWidthInPx){
                //remove width in style
                // //console.log('Increasing...'+(prevWidthInPx+(totColsIncreased*(colWidthInPx/2)))+'<'+currentColWidthInPx)
                var prevClass='';
                colsToSet = (noOfColsCalculated+1);
                if(colsToSet>12){
                    colsToSet = 12;
                } else if(colsToSet<1){
                    colsToSet = 1;
                }
                // //console.log('Increasing...');
                currentResizerLabel.textContent = String(colsToSet);
                //document.getElementById('resizeStatus').innerHTML='Increasing...|calculated Col:'+(noOfColsCalculated+1)+'|prevClass :: '+prevClass+'|colsCrossed:: '+colsCrossed;
            } 
            else if((prevWidthInPx-(totColsIncreased*(colWidthInPx/2)))>currentColWidthInPx){
                // //console.log('Decreasing...'+(prevWidthInPx-(totColsIncreased*(colWidthInPx/2)))+'>'+currentColWidthInPx)
                colsToSet = (noOfColsCalculated);
                if(colsToSet>12){
                    colsToSet = 12;
                } else if(colsToSet<1){
                    colsToSet = 1;
                }
            
                currentResizerLabel.textContent = String(colsToSet);
                //document.getElementById('resizeStatus').innerHTML='Decreasing...|calculated Col:'+noOfColsCalculated+'|prevClass :: '+prevClass+'|colsCrossed ::'+colsCrossed;
            }
        
        
            }
            requestAnimationFrame = window.requestAnimationFrame(resize)
        }
        
        function stopResize(e) {
            if(resizingColwidth){
                resizingColwidth= false;
            if(colsToSet!==0 ){
             console.log("stopResize column", e, e.target, props.data?.id ,window?.resizerRefSent_col);
            //  const targetElem=e.target.getAttribute("elem_type");
            //  const targetId=e.target.getAttribute("id");
             if(data?.id===window?.resizerRefSent_col ){
            if(colsToSet<1 || colsToSet>12){
                // alert('Here 541');
                colsToSet = parseInt(prevCol);
            } 
            else {
                var containsMD = false;
                for(let i=0;i<element.classList.length;i++){
                    var cls = element.classList[i];
                    // //console.log('cls :: '+cls);
                    if(cls.startsWith('col-md-')){
                        containsMD = true;
                    }
                }
                // //console.log('containsMD:: '+containsMD+'|colsToSet:: '+colsToSet);

                const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");

                    if(deviceFromDom==="web"){
                        data.w = parseInt(colsToSet);
                        // data.sm = parseInt(colsToSet);
                        // data.xs = parseInt(colsToSet);
                    }
                    else if(deviceFromDom==="tablet"){
                        data.sm = parseInt(colsToSet);
                    }
                    else if(deviceFromDom==="mobile"){
                        data.xs = parseInt(colsToSet);
                    }

                    data.md = parseInt(colsToSet);

                if(containsMD===false){
                    element.classList.add('col-md-'+colsToSet);
                }
            }
            prevColState.current = data;
            element.style.minWidth = "unset";
            const totalNewColumnWidth = colWidthInPx*colsToSet;
            updateColumnWidth({...data},'md',parseInt(colsToSet));
            
            }
            }
            setUpdatingColumn(false);
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize);
            window.cancelAnimationFrame(requestAnimationFrame)
            stopResizeUIchanges();
            }
        }
        function stopResizeUIchanges(){
            if(element!==null && element.style!==null){
                if(element.style.width!==null){
                    element.style.width=null;
                }
                if(element.style.borderWidth!==null){
                    element.style.borderWidth=null;
                }
                if(element.style.borderStyle!==null){
                    element.style.borderStyle=null;
                }
                if(element.style.borderColor!==null){
                    element.style.borderColor=null;
                }
                if(element.style.opacity!==null){
                    element.style.opacity=null;
                }
                if(currentResizer.style.opacity!==null){
                    currentResizer.style.opacity=null;
                }
                if(currentResizerLabel.style.opacity!==null){
                    currentResizerLabel.style.opacity=null;
                }
                if(element.style.width!==null){
                    element.style.width = null;
                }
                if(element.style.maxWidth!==null){
                    element.style.maxWidth = null;
                }
                if(prevBorder!==null && prevBorder!==undefined && prevBorder!=='' ){
                    element.style.border = prevBorder;
                }
            }
        }
	    }
    
    function makeResizableColHeight(div){
        var element = document.getElementById(div);
        var currentResizer = document.getElementById(div + 'Resizer2');
        var parentHeightinPx = element?.parentElement?.offsetHeight;
        var prevHeightInPx = element?.offsetHeight;
        var columnsDiv = element?.parentElement?.childNodes;
        var colHeightInPx = 0;
        var resizingColHeight=false;
        let requestAnimationFrame;

        if(currentResizer !==null){
                currentResizer.addEventListener('mousedown', mousedownFunc);
        }
        function mousedownFunc(e){
            function isResizing(e){
                if(e?.target?.id===div+"Resizer2"){
                    return true;
                }
                else{
                    return false;
                }

            }

            resizingColHeight=isResizing(e);

            if(resizingColHeight){
           
            e.preventDefault();
            const formstatefromRedux = getFormState2();
            const currentColHeightInPx = e.pageY - element.getBoundingClientRect().top;
            element.style.height = currentColHeightInPx+'px';
            // columnStyle.opacity =  1;
            currentResizer.style.opacity=1;
            element.style.opacity=1;
            prevBorder = element.style.border;
            let parentRow = e.currentTarget.closest(`[elem_type=row]`).id;
            let json = getElementJson(formstatefromRedux, parentRow, "row");

            setColumns(json.children);
            window.addEventListener('mousemove', resize);
            window.addEventListener('mouseup', stopResize);  
            }
        }
        function resize(e) {
            if(resizingColHeight){
            // e.stopPropagation();
            var childHeightInPx = element.firstChild.offsetHeight;
            var currentColHeightInPx = (e.pageY - element.getBoundingClientRect().top);
            var currentDiff = currentColHeightInPx - prevHeightInPx;
            
            if(childHeightInPx < currentColHeightInPx){
                element.style.height = currentColHeightInPx+'px';                

                // for(let i=0; i<columnsDiv.length-1; i++){
                //     console.log("chill",i,currentColHeightInPx , columnsDiv[i].offsetHeight, currentDiff);
                //     if(currentColHeightInPx > columnsDiv[i].offsetHeight){
                //         console.log("chill..", i,columnsDiv[i].offsetHeight, currentColHeightInPx,prevHeightInPx,currentDiff);
                //         if( currentColHeightInPx > columnsDiv[i].offsetHeight + currentDiff && currentDiff > 0){
                //             console.log("chill...", i,columnsDiv[i].offsetHeight, currentColHeightInPx,prevHeightInPx,currentDiff);
                //         }
                //     }
                // }
            } 
            // else {
            //     element.style.height = "auto";
            //     element.style.maxHeight = null;
            // }
           
            if(currentColHeightInPx<0){
                currentColHeightInPx = 0;
            } else if(currentColHeightInPx>parentHeightinPx){
                currentColHeightInPx = parentHeightinPx-2;
            }
            
        
            }
            requestAnimationFrame = window.requestAnimationFrame(resize);
        }
        
        function stopResize(e){

            if(resizingColHeight){
                resizingColHeight=false;
            // e.stopPropagation();
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize); 
            window.cancelAnimationFrame(requestAnimationFrame)
            currentResizer.style.opacity=null;
            prevHeightInPx = element.offsetHeight;
            columnStyle["height"] = element.style.height;
            // columnStyle.maxHeight = element.style.maxHeight;
            props.data.style["colheight"] = element.style.height;
            props.data.style["colheight2"] = element.style.height;
            props.data.style.heightselect = "set"
            
            // if (JSON.stringify(data) !== JSON.stringify(prevColState.current)) {
            //     prevColState.current = data;
            // }
            updateColumnWidth({...data},'md',element.style.height, "height");
            // updatedComponentInFormState(
            //     props.id,
            //     props.data
            // );
            }
            dispatch(updateStateInRedux({name: "controlSelected", key: props.containerId, value: props.data}));
        }
    }
    function makeResizableColWidthHeight(div){
        var element = document.getElementById(div);
        var currentResizer = document.getElementById(div+'Resizer3');
        var parentHeightinPx = element?.parentElement?.offsetHeight;
        var prevHeightInPx = element?.offsetHeight;
        var parentWidthinPx = element?.parentElement?.offsetWidth;
        var prevWidthInPx = element?.offsetWidth;
        var resizingColHeight=false;
        let requestAnimationFrame;
        var colWidthInPx =0;
        var resizingColwidth=false;

        if(currentResizer !==null){
                currentResizer.addEventListener('mousedown', mousedownFunc);
        }
        function mousedownFunc(e){
            function isResizing(e){
                if(e?.target?.id===div+"Resizer3"){
                    return true;
                }
                else{
                    return false;
                }

            }
            resizingColwidth = isResizing(e);
            resizingColHeight=isResizing(e);

            if(resizingColHeight){
           
            e.preventDefault();
            const formstatefromRedux = getFormState2();
            const currentColHeightInPx = e.pageY - element.getBoundingClientRect().top;
            element.style.height = currentColHeightInPx+'px';
            // columnStyle.opacity =  1;
            currentResizer.style.opacity=1;
            element.style.opacity=1;
            prevBorder = element.style.border;
            let parentRow = e.currentTarget.closest(`[elem_type=row]`).id;
            let json = getElementJson(formstatefromRedux, parentRow, "row");

            setColumns(json.children);
            window.addEventListener('mousemove', resize);
            window.addEventListener('mouseup', stopResize);  
            }
            if( resizingColwidth ){
                window.resizerRefSent_col=e.target.getAttribute("name");
                prevWidthInPx = element.offsetWidth;
                classes = element.classList;
                let currentColWidthInPx
                if (translationStyles1) {
                    currentColWidthInPx = element.getBoundingClientRect().right - e.pageX;
                }
                else {
                    currentColWidthInPx = e.pageX - element.getBoundingClientRect().left;
                }
                element.style.width = currentColWidthInPx+'px';
                element.style.maxWidth = 'unset';
                element.style.minWidth = 'unset';


                currentResizer.style.opacity=1;
                currentResizer.style.cursor='nw-resize';
                parentWidthinPx = element.parentElement.offsetWidth;
                colWidthInPx = Math.floor(parentWidthinPx/12);
                element.classList.add('resizers');
                prevBorder = element.style.border;

                // for(var cls=0;cls<classes.length;cls++){
                //     var css_class = classes[cls];
                //     if(css_class.startsWith('col-')){
                //         element.classList.remove(css_class);
                //     }
                // }
                element.style.opacity=1;
                
                colsCrossed = 0;
                e.preventDefault();
                
                //for resizer
                currentResizer.style.opacity=1;

                // window.addEventListener('mousemove', resize);
                // window.addEventListener('mouseup', stopResize);
                // window.removeEventListener('mousemove', resize);
                // window.removeEventListener('mouseup', stopResize);
                window.addEventListener('mousemove', resize);
                window.addEventListener('mouseup', stopResize);
            }

        }
        function resize(e) {
            if(resizingColHeight){
            // e.stopPropagation();
            var childHeightInPx = element.firstChild.offsetHeight;
            var currentColHeightInPx = (e.pageY - element.getBoundingClientRect().top);
            var currentDiff = currentColHeightInPx - prevHeightInPx;
            
            if(childHeightInPx < currentColHeightInPx){
                element.style.height = currentColHeightInPx+'px';        
            }             
            if(currentColHeightInPx<0){
                currentColHeightInPx = 0;
            } else if(currentColHeightInPx>parentHeightinPx){
                currentColHeightInPx = parentHeightinPx-2;
            }
            
        
            }
            if(resizingColwidth){
                for(var cls=0;cls<classes.length;cls++){
                    var css_class = classes[cls];
                    if(css_class.startsWith('col-')){
                        element.classList.remove(css_class);
                    }
                }
                    var currentColWidthInPx;
                    if (translationStyles1) {
                        currentColWidthInPx = element.getBoundingClientRect().right - e.pageX;
                    }
                    else {
                        currentColWidthInPx = e.pageX - element.getBoundingClientRect().left;
                    }
                element.style.width = currentColWidthInPx+'px'; //To show smooth transition
                element.style.minWidth = currentColWidthInPx+'px';
                // element.style.minWidth = 'unset';
    
                // //console.log('currentColWidthInPx :: '+currentColWidthInPx);
                if(currentColWidthInPx < 0){
                    currentColWidthInPx = 0;
                }
                else if(currentColWidthInPx > parentWidthinPx){
                    currentColWidthInPx = parentWidthinPx-2;
                }
                //cols calculation
                var noOfColsCalculated = (Math.floor(currentColWidthInPx/colWidthInPx));
                if(noOfColsCalculated<1){
                    noOfColsCalculated =1;
                } else if(noOfColsCalculated>12){
                    noOfColsCalculated=12;
                }
                var totColsIncreased = Math.abs(prevCol - noOfColsCalculated);
                totColsIncreased = 1;
                // //console.log('totColsIncreased :: '+totColsIncreased);
                if((prevWidthInPx+(totColsIncreased*Math.floor(colWidthInPx/2)))<currentColWidthInPx){
                    //remove width in style
                    // //console.log('Increasing...'+(prevWidthInPx+(totColsIncreased*(colWidthInPx/2)))+'<'+currentColWidthInPx)
                    var prevClass='';
                    colsToSet = (noOfColsCalculated+1);
                    if(colsToSet>12){
                        colsToSet = 12;
                    } else if(colsToSet<1){
                        colsToSet = 1;
                    }
                    // //console.log('Increasing...');
                    // currentResizerLabel.innerHTML=colsToSet;
                    //document.getElementById('resizeStatus').innerHTML='Increasing...|calculated Col:'+(noOfColsCalculated+1)+'|prevClass :: '+prevClass+'|colsCrossed:: '+colsCrossed;
                } 
                else if((prevWidthInPx-(totColsIncreased*(colWidthInPx/2)))>currentColWidthInPx){
                    // //console.log('Decreasing...'+(prevWidthInPx-(totColsIncreased*(colWidthInPx/2)))+'>'+currentColWidthInPx)
                    colsToSet = (noOfColsCalculated);
                    if(colsToSet>12){
                        colsToSet = 12;
                    } else if(colsToSet<1){
                        colsToSet = 1;
                    }
                
                    // currentResizerLabel.innerHTML=colsToSet;
                    //document.getElementById('resizeStatus').innerHTML='Decreasing...|calculated Col:'+noOfColsCalculated+'|prevClass :: '+prevClass+'|colsCrossed ::'+colsCrossed;
                }
            
            
                }
            requestAnimationFrame = window.requestAnimationFrame(resize);
        }
        
        function stopResize(e){

            if(resizingColHeight){
                resizingColHeight=false;
            // e.stopPropagation();
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize); 
            window.cancelAnimationFrame(requestAnimationFrame)
            currentResizer.style.opacity=null;
            prevHeightInPx = element.offsetHeight;
            columnStyle["height"] = element.style.height;
            // columnStyle.maxHeight = element.style.maxHeight;
            props.data.style["colheight"] = element.style.height;
            props.data.style["colheight2"] = element.style.height;
            props.data.style.heightselect = 'set';
            
            // if (JSON.stringify(data) !== JSON.stringify(prevColState.current)) {
            //     prevColState.current = data;
            // }
            updateColumnWidth({...data},'md',element.style.height, "height");
            // updatedComponentInFormState(
            //     props.id,
            //     props.data
            // );
            }
            if(resizingColwidth){
                resizingColwidth= false;
            if(colsToSet!==0 ){
             console.log("stopResize column", e, e.target, props.data?.id ,window?.resizerRefSent_col);
            //  const targetElem=e.target.getAttribute("elem_type");
            //  const targetId=e.target.getAttribute("id");
             if(data?.id===window?.resizerRefSent_col ){
            if(colsToSet<1 || colsToSet>12){
                // alert('Here 541');
                colsToSet = parseInt(prevCol);
            } 
            else {
                var containsMD = false;
                for(let i=0;i<element.classList.length;i++){
                    var cls = element.classList[i];
                    // //console.log('cls :: '+cls);
                    if(cls.startsWith('col-md-')){
                        containsMD = true;
                    }
                }
                // //console.log('containsMD:: '+containsMD+'|colsToSet:: '+colsToSet);

                const deviceFromDom=document.querySelector("#canvasId")?.getAttribute("deviceMode");

                    if(deviceFromDom==="web"){
                        data.w = parseInt(colsToSet);
                        // data.sm = parseInt(colsToSet);
                        // data.xs = parseInt(colsToSet);
                    }
                    else if(deviceFromDom==="tablet"){
                        data.sm = parseInt(colsToSet);
                    }
                    else if(deviceFromDom==="mobile"){
                        data.xs = parseInt(colsToSet);
                    }

                    data.md = parseInt(colsToSet);

                if(containsMD===false){
                    element.classList.add('col-md-'+colsToSet);
                }
            }
            prevColState.current = data;
            element.style.minWidth = "unset";
            const totalNewColumnWidth = colWidthInPx*colsToSet;
            updateColumnWidth({...data},'md',parseInt(colsToSet));
            
            }
            }
            setUpdatingColumn(false);
            window.removeEventListener('mousemove', resize);
            window.removeEventListener('mouseup', stopResize);
            window.cancelAnimationFrame(requestAnimationFrame)
            // stopResizeUIchanges();
            }
            dispatch(updateStateInRedux({name: "controlSelected", key: props.containerId, value: props.data}));
        }
    }
    
    var stateEquality = function(obj1, obj2) { 
        var ret = {}; 
        for(var i in obj2) { 
          if(!obj1.hasOwnProperty(i) || obj2[i] !== obj1[i]) { 
            //ret[i] = obj2[i]; 
            return false;
          } 
        } 
        return true; 
    };

    const linebreak=false;
  
    const conditionalQuickToolOpening =
    props.id === openQuickToolFor ? true : false
  
    const { updatedComponentInFormState, removeAndUpdateComponentInFormState} =updateJson; 

    const isSubformInPage = props?.isSubformInPage || false;
    let isMigrationClient = window.psh_configs?.isMigrationClient?.[formState2?.formName] ?? false;

    let controlSpacing={
     spacingTop : "8px",
     spacingBottom : "8px",
     spacingLeft:"12px",
     spacingRight:"12px",
    }
    var themeData = formState2.theme;
      var spacingColumn = "" ;

    if(themeData.SpacingType === "Default Spacing" || isMigrationClient) {
        if(themeData && themeData['BasicTheme'] && themeData['BasicTheme']['Spacing']){
          spacingColumn = themeData['BasicTheme']['Spacing'] ;
        }
    
      if (spacingColumn === 'Compressed') {
        controlSpacing.spacingTop = "2px"
        controlSpacing.spacingBottom = "2px"
        controlSpacing.spacingLeft = "8px"
        controlSpacing.spacingRight = "8px"
      }
      else if (spacingColumn === 'Compact') {
        controlSpacing.spacingTop = isMigrationClient ? '2.5px' : "4px"
        controlSpacing.spacingBottom = isMigrationClient ? '2.5px' : "4px"
        controlSpacing.spacingLeft = isMigrationClient ? '2.5px' : "8px"
        controlSpacing.spacingRight = isMigrationClient ? '2.5px' : "8px"
      } else if (spacingColumn === 'Regular') {
        controlSpacing.spacingTop = isMigrationClient ? '5px' : "8px"
        controlSpacing.spacingBottom = isMigrationClient ? '5px' : "8px"
        controlSpacing.spacingLeft = isMigrationClient ? '5px' : "12px"
        controlSpacing.spacingRight = isMigrationClient ? '5px' : "12px"
      } else if (spacingColumn === 'Expand') {
        controlSpacing.spacingTop = isMigrationClient ? '7.5px' : "12px"
        controlSpacing.spacingBottom = isMigrationClient ? '7.5px' : "12px"
        controlSpacing.spacingLeft = isMigrationClient ? '7.5px' : "12px"
        controlSpacing.spacingRight = isMigrationClient ? '7.5px' : "12px"
      }
      else if (spacingColumn === 'Spacious') {
        controlSpacing.spacingTop = "16px"
        controlSpacing.spacingBottom = "16px"
        controlSpacing.spacingLeft = "16px"
        controlSpacing.spacingRight = "16px"
      }    
    } else {
        controlSpacing.spacingTop = `${themeData?.["Control Spacing"]?.["Spacing Top"] || 8}px`;
        controlSpacing.spacingLeft = `${themeData?.["Control Spacing"]?.["Spacing Left"] || 12}px`;
        controlSpacing.spacingRight = `${themeData?.["Control Spacing"]?.["Spacing Right"] || 12}px`;
        controlSpacing.spacingBottom = `${themeData?.["Control Spacing"]?.["Spacing Bottom"] || 8}px`;
    }


    let device;

    const resizeObserverRef = useRef(null);
    const [column_Height, setColumn_Height] = useState();
    // const colRef = useRef()

    useLayoutEffect(() => {
        // Initialize ResizeObserver and attach it to the div element
        // if(!props.previewmode){
            let targetElement;
            // if(!props?.previewmode)
            targetElement = document.querySelector(`#${props.data.id}`)?.firstElementChild // Replace with your selector
            // if(props?.previewmode)
            // targetElement = document.querySelector(`#${props.data.id}`)

            if (!targetElement) {
            console.error('Element not found');
            return;
            }
    
            resizeObserverRef.current = new ResizeObserver((entries) => {
            for (const entry of entries) {
                const { width, height, top, bottom } = entry.contentRect;
                console.log('Width1:', width);
                console.log('Height1:', height);
                // if(!props?.previewmode)
                setColumn_Height(height)
                console.log('Top1:', top);
                console.log('Bottom1:', bottom);
            }
            });
    
            // Start observing the div element
            // if(!props?.previewmode){
                // if (colRef.current) {
                resizeObserverRef.current.observe(targetElement);
                // }
            // }
    
            // Cleanup function
            return () => {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.unobserve(targetElement);
            }
            };
        // }
    }, []);
    
    const calculateHeight = (colHeight , paddingTop, paddingBottom) => {
        return parseInt(colHeight ? colHeight?.replace("px", "") : 0) + parseInt(paddingTop ? paddingTop?.replace("px", "") : 0) + parseInt(paddingBottom ? paddingBottom?.replace("px", "") : 0) + 2;
    }

    if(props.data.style){
        columnStyle["paddingLeft"]=props.data.style["colPadding"] === "true" || children?.length === 0? '0px' : controlSpacing?.spacingLeft;
        columnStyle["paddingRight"]=props.data.style["colPadding"] === "true" || children?.length === 0? '0px' : controlSpacing?.spacingRight;
        columnStyle["paddingBottom"]=props.data.style["colPadding"] === "true" || children?.length === 0? '0px' : controlSpacing?.spacingBottom ;
        columnStyle["paddingTop"]=props.data.style["colPadding"] === "true" || children?.length === 0? '0px' : controlSpacing?.spacingTop;
        columnStyle["boxSizing"] = "border-box";
        columnStyle["display"]="block";
        if(document.getElementById(props?.data?.id)){
            if(document.getElementById(props.data.id)?.style){
                if(document.getElementById(props.data.id)?.style?.display === 'none'){
                    columnStyle["display"]="none";
                }
                else{
                    columnStyle["display"]="block";
                }
            }
            else{
                columnStyle["display"]="block";
            }

        }
        else{
            columnStyle["display"]="block";
        }

        // const colChild_height= column_Height
        const newHeight = column_Height

        if(props?.data?.style?.heightselect === "set") {
        if(newHeight && newHeight > 40 && props?.data?.children?.[0]?.controlName !== "doclist"){
            columnStyle["height"] =
            newHeight >
            parseInt(props?.data?.style?.["colheight1"] ? props.data.style["colheight1"].replace("px", "") : 0)
            ? `${newHeight}px`
            : props.data.style["colheight1"];
            const height = props.data.style['colheight2'] ? parseInt(props.data.style['colheight2'] ? props.data.style['colheight2']?.replace("px", "") : 0) : calculateHeight(columnStyle["height"],columnStyle["paddingTop"],columnStyle["paddingBottom"]); 
            if(`${height}px` !== props.data.style['colheight']) {
                props.data.style["colheight"] = `${height}px`;
            }
        }
        columnStyle["height"] = props?.data?.style?.["colheight"] || "auto"
        } else {
            columnStyle["height"] = "auto";
        }

        // columnStyle.maxHeight = props.data.style["colheight"];
    }
    
    useEffect(() => {
        // console.log('Column useEffect');
        if (!props?.previewmode) {
            const ele = document.getElementById(props.id);
            // Store references to handlers so they can be removed
            const dragEnterHandler = function (e) {
                e.preventDefault();
                if (draggedFrom !== "") {
                    ele.classList.add('LeftBorder');
                }
            };
            const dragOverHandler = function (e) {
                e.preventDefault();
                if (draggedFrom !== "") {
                    ele.classList.add('LeftBorder');
                }
            };
            const dragLeaveHandler = function (e) {
                e.preventDefault();
                ele.classList.remove('LeftBorder');
            };
            const dropHandler = function (e) {
                e.preventDefault();
                ele.classList.remove('LeftBorder');
            };
            if (ele !== null && ele !== undefined) {
                ele.addEventListener('dragEnter', dragEnterHandler);
                ele.addEventListener('dragover', dragOverHandler);
                ele.addEventListener('dragleave', dragLeaveHandler);
                ele.addEventListener('drop', dropHandler);
            }
            // Cleanup function to remove listeners
            return () => {
                if (ele !== null && ele !== undefined) {
                    ele.removeEventListener('dragEnter', dragEnterHandler);
                    ele.removeEventListener('dragover', dragOverHandler);
                    ele.removeEventListener('dragleave', dragLeaveHandler);
                    ele.removeEventListener('drop', dropHandler);
                }
            };
        }
    }, []);
       
    var columnElement=document.getElementById("design_page") 
    // // && document.getElementById(props.id).parentElement;
    // const [windowWidth, setWindowWidth] = useState();
    



    

    // // const columnWidth=useElementWidth("design_page", props?.previewmode);

    // function checkWidthOnResizeOfWindow(){
    //     var widthOfPreviewColumn;
    //     if(columnElement!==null){
    //      widthOfPreviewColumn=columnElement.getBoundingClientRect().width;
    //     }
    //     widthOfPreviewColumn=widthOfPreviewColumn+50;

    
    //     if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && ((widthOfPreviewColumn >= (formState2 && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]) ) )
    //     && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Mobile"] && parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"])))))
    //         {
    //           setDevicePreview("mobile");
    //         }     
    //     else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"])) )
    //       && (widthOfPreviewColumn < ( formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Tab"] && parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"])))))
    //     {
    //         setDevicePreview("tab");
    //     }
    //     else if(formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && ((widthOfPreviewColumn >= (formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["StartValue"])) )
    //       && (widthOfPreviewColumn < (formState2 && formState2.style && formState2.style?.["Breakpoint"] && formState2.style?.["Breakpoint"]?.["Desktop"] && formState2.style?.["Breakpoint"]?.["Desktop"] && parseInt(formState2.style?.["Breakpoint"]?.["Desktop"]?.["EndValue"]))))){
    //         setDevicePreview("web");
    //       }
    //       else{
    //         setDevicePreview("web");
    //     }
    
    //    setWindowWidth(window.innerWidth);
    
    // };

    //  useEffect(()=>{
    //         checkWidthOnResizeOfWindow();
            
    //         const elementForWidth= document.getElementById("design_page") || document.getElementById("canvasId");
    //             window.addEventListener("resize",checkWidthOnResizeOfWindow);
    //             elementForWidth.addEventListener("resize",checkWidthOnResizeOfWindow);
    //          return () => { 
    //             window.removeEventListener("resize", checkWidthOnResizeOfWindow);
    //             elementForWidth.removeEventListener("resize", checkWidthOnResizeOfWindow);
    //         };
        
    //  },[])

    //  useEffect(()=>{
    //     if(formMataData) {
    //         checkWidthOnResizeOfWindow();
    //     }
    //  },[tempCanWidth]);

    const [mobileDisplay, setMobileDisplay] = useState(true);
    const [tabDisplay, setTabDisplay] = useState(true);

    const startMobile = useRef();
    const endMobile= useRef();
    const startTab= useRef();
    const endTab= useRef();

    useEffect(()=>{
        if (formState2 && formState2.style) {
            startMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["StartValue"]);
            endMobile.current = parseInt(formState2.style?.["Breakpoint"]?.["Mobile"]?.["EndValue"]);
            startTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["StartValue"]);
            endTab.current = parseInt(formState2.style?.["Breakpoint"]?.["Tab"]?.["EndValue"]);
        }

        let displayWidth = getTempCanWidth();

        if(props?.previewmode && displayWidth){
            let hideColumn = false;
            

            if(children && children.length === 1){
               children.map((data,index) => {
                    if (data && data.style && (data.style["Visible"] === "false"||data.style["Visible"] === false)) {
                        hideColumn = true;
                    }
                    if(data && data.style && data.style?.["MobileVisible"]==="false" && ( (displayWidth <= endMobile?.current && displayWidth >= startMobile?.current) || devicePreview === "mobile") ){
                        setMobileDisplay(false);
                        hideColumn = true;
                    } else {
                        setMobileDisplay(true);
                    }
                    if(data && data.style && data.style?.["TabsVisible"]==="false" && ( (displayWidth <= endTab?.current && displayWidth >= startTab?.current ) || devicePreview === "tablet") ){
                        setTabDisplay(false);
                        hideColumn = true;
                    }
                    else {
                        setTabDisplay(true);
                    }
                })  
            } else if(children && children.length === 0) {
                if(props.data?.style?.["columnVisibility"] !== "false") {
                    hideColumn = false;
                }
                else
                    hideColumn = true;
                columnStyle["paddingLeft"]= '0px';
                columnStyle["paddingRight"]= '0px'
                columnStyle["paddingBottom"]= '0px';
                columnStyle["paddingTop"]= '0px';
            }else {
                let tempMobile = false;
                let tempTab = false;
                hideColumn= children.every((child)=>{
                    if (child && child.style && (child.style["Visible"] === "false"||child.style["Visible"] === false)) {
                       return true
                        }
                })
               children.map((data)=>{                   
                    if(data && data.style && data.style?.["MobileVisible"]==="true"){
                        tempMobile = true;
                        return;
                    }
                });
               children.map((data)=>{
                    if(data && data.style && data.style?.["TabsVisible"]==="true"){
                        tempTab = true;
                        return;
                    }
                })
    
                if(tempMobile === false &&  ( (displayWidth <= endMobile?.current && displayWidth >= startMobile?.current ) || devicePreview === "mobile") ){
                    setMobileDisplay(false);
                } else {
                    setMobileDisplay(true);
                }
    
                if(tempTab === false &&  ( (displayWidth <= endTab?.current && displayWidth >= startTab?.current ) || devicePreview === "tablet") ){
                    setTabDisplay(false);
                } else {
                    setTabDisplay(true);
                }
            }
            if(document.getElementById(props?.data?.id) && hideColumn ) {
                if(props.data?.style?.["columnVisibility"] === "true") {
                    document.getElementById(props.data.id).style.display = 'block';
                    document.getElementById(props.data.id).style.visibility = 'hidden';
                    columnStyle["visibility"] = "hidden";
                    columnStyle["display"] = "block"
                    const allChildrenHidden = props?.data?.children?.every(child => child?.style?.Visible === "false");
                    if(props?.data?.children.length === 0 || allChildrenHidden) { columnStyle["padding"]= "0px"}
                } else {
                    document.getElementById(props.data.id).style.display = 'none';
                    columnStyle["display"] = "none"
                }
            }else{
                document.getElementById(props.data.id).style.display = 'block';
                columnStyle["display"] = "block"
                if(props?.data?.children.length === 0 && props.previewmode) {columnStyle["padding"] = "0px"}
            }

            if(props?.data?.style) {
                props.data.style.Visible = `${!hideColumn}`;
            }
        }
    }, [devicePreview, tabDisplay, mobileDisplay, tempCanWidth, JSON.stringify(props?.data?.children)])

    useEffect(()=>{
        // if(props.data?.style?.["columnVisibility"] === "true") {
           const hasVisibleChild = props?.data?.children?.some(child => child?.style?.Visible === "true");
           if(hasVisibleChild) {
            if((columnStyle["padding"] ==="0px" || columnStyle["padding"] === undefined) && props?.data?.style?.colPadding !== "true" && document.getElementById(props.data.id) && document.getElementById(props.data.id)?.style){
            document.getElementById(props.data.id).style.padding = `${controlSpacing.spacingTop} ${controlSpacing.spacingRight} ${controlSpacing.spacingBottom} ${controlSpacing.spacingLeft}`
            }
        }
        // }
       },[props?.data?.style?.["columnVisibility"], JSON.stringify(props?.data?.children)])
    var childrenHidden= undefined;

    setMax_controlIdValue(props.data.id, "column");
    // if(childrenHidden===undefined || childrenHidden===true){

    // }

    if(children!==null && children!==undefined){
        if(children.length===0){
            areChildrenPresent = true;
            columnStyle={...columnStyle, border: '1px dashed transparent' , display :props.data?.style?.["columnVisibility"] !== "false" || !props.previewmode ? "block" : "none" /*, backgroundColor:'#F8F8F8'*/};
            if(!props.previewmode){
                // if(props.id === props.selected.id){
                //     columnStyle.border = '1px dashed #000000';
                // } else {
                    columnStyle.border = '1px dashed #ced4da';
                // }
            }
            else if(props.previewmode){
                columnStyle={...columnStyle}
            }
        }
        else {
            if(props.previewmode){
                columnStyle={...columnStyle}
            } else {
                columnStyle={...columnStyle, border: '1px dashed transparent'};
            }
        }
    }

    if(props.previewmode){
        return (
            <>
            {linebreak && <break></break> }
            { props && props.id &&
           
            <Col  
                id={props.id} 
                column_id={props.id}
                style={mobileDisplay === false || tabDisplay === false ? {display:"none"} : columnStyle}
                elem_type="column" 
                md={data.md}
                sm={data.sm}
                xs={data.xs}
                data-placement="top" 
                frameindex={data.frameIndex}
                elementIndex={props.elementIndex} 
                sheetIndex={props.sheetIndex}
                sheetElementIndex={props.sheetElementIndex}
            >
                {props && props.children ?
                (
                    <Fragment>
                        <div key={props.id} data-id={props.id} style={{ display: "block" }}>
                            {props.renderChild}
                        </div>
                    </Fragment>
                )
                :null
                }
            </Col>
            }
            </>
        );
    } 
    else {
        return (
          <>
            {linebreak && <break></break>}
            {props && props.id && (
              <>
              <Fade in={animate}>
<>
                <Col
                  id={props.id}
                  column_id={props.id}
                  elem_type="column"
                //   ref={colRef}
                  control_id={data.id}
                  md={data.md}
                  sm={data.sm}
                  xs={data.xs}
                  className={(!hoverColumn && !isSubformInPage) ? `${styles.col_css} ${styles.col_css1}` :`${styles.col_css}`}
                  data-placement="top"
                  frameindex={data.frameIndex}
                  elementIndex={props.elementIndex}
                  sheetIndex={props.sheetIndex}
                  sheetElementIndex={props.sheetElementIndex}
                  tabIndex={activeTabIndex}
                  onClick={(e) => props.handleSelected(e, props.id, "n")}                  
                  onKeyDown={(e) => props.handleSelected(e)}
                  style={ columnStyle}
                  draggable={false}
                  onDragStart={props.handleReorderStart}
                  onDrop={(ev) => {
                    if(props?.data?.isInsideListview){
                        handleListviewControlSwapping(ev, props.data);
                    }else{
                        props.handleReorderDrop(ev, props.data.elem_type, undefined, undefined, props.data.isWizardHeader)
                    }
                  } 
                  }
                >
                  {props && props.children ? (
                    <Fragment>
                    <div key={props.id}>
                        {props.renderChild}
                    </div>
{before_colIndicator(columnStyle)}
                    {after_colIndicator(columnStyle)}
                      <div
                        className={`${styles.resizerLabel} resizerLabel`}
                        id={props.id + "ResizerLabel"}
                        elem_type="column"
                        control_id={props.id}
                        style={{cursor: "pointer"}}
                        name={props.id}
                      ></div>
                      {isMobile ? null : (
                        <>
                            <div
                                onHover={()=>{
                                    setUpdatingColumnWidth(prev => !prev);
                                }}
                                onMouseDown={() =>{
                                    props.setDragging(true);  
                                }}
                                onMouseUp={() => {
                                    props.setDragging(false);  
                                }}
                                className={(!hoverColumn && !isSubformInPage)  ? `${styles.resizer} resizer` : ''}
                                id={props.id + "Resizer"}
                                name={props.id}
                                control_id={props.id}
                                style={{left: translationStyles1 ? "-6px" : "initial", right: translationStyles1 ? "initial" : "-6px"}}
                            ></div>
                            <div
                                className={(!hoverColumn && !isSubformInPage) ?`${styles.resizer2} resizer2` :''}
                                id={props.id + "Resizer2"}
                                control_id={props.id}
                                name={props.id}
                            >
                            </div>
                            <div
                                className={(!hoverColumn && !isSubformInPage) ?`${styles.resizer3} resizer3` :''}
                                id={props.id + "Resizer3"}
                                control_id={props.id}
                                name={props.id}
                            >
                            </div>
                        </>
                      )}
                    {controlSelected?.id === props?.id &&
                      <ElemDeleteControl
                        isSubformInPage={isSubformInPage}
                        containerId={props.containerId}
                        id={props.id}
                        data={props.data}
                        deleteControl={deleteControl}
                        handleReorderStart={props.handleReorderStart}
                        handleReorderDrop={props.handleReorderDrop}
                        dragId={props.id}
                        dragType={"column"}
                        elemType={props.data.elem_type}
                      />
                    }
                    </Fragment>
                  ) :
                  null}
                </Col>
</>
              </Fade>
              </>
            )}
          </>
        );
    }
}

export default COLUMN